import { connect } from 'react-redux'
import { purgeState } from '../../../utils/localStorage'
import { initializeNodes } from '../actions'
import {
  getFirstIncomplete,
  getIsIncompleteByKey,
  getSelectionByKey,
} from '../../selection/selectors'
import { getTopSteps } from '../selectors'
import MainLayout from '../components/mainLayout'

const topSteps = [
  'plot',
  'budget',
  'houseType',
  'configuration',
  'offer',
]

const getCurrentPath = ({ location }) => {
  const currentPath = location.pathname.split('/')
  currentPath.shift()
  return currentPath
}

const mapStateToProps = (state, ownProps) => ({
  budget: getSelectionByKey({
    state,
    key: 'budget',
  }),
  currentPath: getCurrentPath(ownProps),
  steps: getTopSteps({
    state,
    topSteps,
  }),
  incomplete: getFirstIncomplete({
    state,
    topSteps,
  }),
  offerIncomplete: getIsIncompleteByKey({
    state,
    key: 'offer',
  }),
  resetApp: () => {
    purgeState()
    window.location.reload()
    ownProps.history.push('/')
  },
})

const mapDispatchToProps = dispatch => ({
  initialize: () => dispatch(initializeNodes()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainLayout)



// WEBPACK FOOTER //
// ./src/modules/core/containers/mainLayout.js